var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vnLogin',{attrs:{"reset":_vm.reset,"isSilent":_vm.isSilent,"autoRefresh":_vm.autoRefresh,"success":_vm.success,"error":_vm.error,"closeLogin":_vm.closeLogin}})}
var staticRenderFns = []

export { render, staticRenderFns }